import Typography from '@mui/material/Typography';
import { format } from "d3-format"
import CardSmall from '../../../../../../components/CockpitCards/CardSmall';
import DiaHeartInfo from './DiaHeartInfo';
import DiaHeartData from './DiaHeartData';
import AgeChart from "./AgeChart";



const bmi_ref = 59;
const bmi_warning = 65;

export default function HeartCard() {

const r_bmi = 54
const age = 60
const bioage = 54
const diffage = age - bioage
const warning_low = age+1;
const warning_red = age+2;

return (
<>
<CardSmall

headline="HEART AGE"
subtext="Your cardiovascular heart age tells you your biological age of your heart organ - compared to your chronological age. Learn what you can do to improve this parameter."
icon_1 = {<DiaHeartInfo />}
icon_2 = {<DiaHeartData />}

leftcontent={<>

   <Typography variant="number" sx={{color: 'traffic.green', 
                                 ...(bioage > warning_low && {color: 'traffic.orange'}), 
                                 ...(bioage > warning_red && {color: 'traffic.red'}), 
                                    }}> 
                            {format(",")(bioage)} <br />       
    </Typography>

            </>}  

rightcontent={<>  <AgeChart />    </>}  

textlines = {<>   <Typography variant="body2" sx={{ml:1, color: 'common.black',  }}> Real age: {age} </Typography> </>}
           
        
    />    
  </>
)};
  